import { Component, Input } from '@angular/core';
import { Page } from 'src/app/interfaces/strapi';
import { NgIf } from '@angular/common';
import { CarouselComponent } from '../carousel/carousel.component';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    imports: [NgIf, CarouselComponent],
})
export class BannerComponent {
  @Input() public pageData!: Page;

  @Input() public cardStyle: 'primary' | 'tertiary' = 'primary';

  @Input() public useAlternateBanner = false;
}
